import { DEFAULT_SCOPE, DEFAULT_BLOCKSTACK_HOST } from './constants';
import { getGlobalObject } from '@stacks/common';
export class AppConfig {
    constructor(scopes, appDomain, redirectPath, manifestPath, coreNode, authenticatorURL) {
        var _a;
        if (scopes === void 0) { scopes = DEFAULT_SCOPE.slice(); }
        if (appDomain === void 0) { appDomain = (_a = getGlobalObject('location', { returnEmptyObject: true })) === null || _a === void 0 ? void 0 : _a.origin; }
        if (redirectPath === void 0) { redirectPath = ''; }
        if (manifestPath === void 0) { manifestPath = '/manifest.json'; }
        if (coreNode === void 0) { coreNode = undefined; }
        if (authenticatorURL === void 0) { authenticatorURL = DEFAULT_BLOCKSTACK_HOST; }
        this.appDomain = appDomain;
        this.scopes = scopes;
        this.redirectPath = redirectPath;
        this.manifestPath = manifestPath;
        this.coreNode = coreNode;
        this.authenticatorURL = authenticatorURL;
    }
    redirectURI() {
        return `${this.appDomain}${this.redirectPath}`;
    }
    manifestURI() {
        return `${this.appDomain}${this.manifestPath}`;
    }
}
//# sourceMappingURL=appConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/auth/dist/esm/appConfig.js
// module id = null
// module chunks = 